import { LocalizationProvider, DateTimePicker } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment-timezone";
import React, { useEffect, useState } from "react";
import { displayDate } from "../../utils/Utils";

const EasyEditDateTimePicker = (props) => {
    const [selectValue, setSelectValue] = useState(null);

    // ⛳️ Set initial value when component mounts
    useEffect(() => {
        if (props.value && props.value !== "N/A") {
            const parsed = moment(props.value);
            setSelectValue(parsed.isValid() ? parsed : null);
        } else {
            setSelectValue(null);
        }
    }, [props.value]);

    // ⛳️ Immediately disable inline editing mode
    useEffect(() => {
        props.setAllowEditInline(false);
    }, []);

    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <DateTimePicker
                label={props.label || "Select Date"}
                format={props?.preferredDateFormat}
                views={["day", "hours", "minutes", "month", "year"]}
                slotProps={{
                    textField: {
                        variant: "filled",
                        name: "expected_closing_date",
                        type: "text",
                        className: "no-margin size-medium control",
                    },
                }}
                value={selectValue}
                onChange={(value) => {
                    setSelectValue(value);
                    const formatted = value?.isValid?.()
                        ? value.format(displayDate(props.preferredDateFormat))
                        : "";
                    props.setParentValue(formatted);
                }}
                error={!!props.errorMessages}
                helperText={props.errorMessages || ""}
            />
        </LocalizationProvider>
    );
};

export default EasyEditDateTimePicker;
